import { render, staticRenderFns } from "./PanelNavigation.vue?vue&type=template&id=45202110&"
import script from "./PanelNavigation.vue?vue&type=script&lang=js&"
export * from "./PanelNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports